export default __webpack_public_path__ + "static/media/spid-idp-intesaid.17d1c6e7.svg";